export const extractAddressComponents = (address_components) => {
  let street = ''
  let colony = ''
  let postalCode = ''
  let city = ''
  let state = ''
  let country = ''

  for (const element of address_components) {
    if (element.types.includes('route')) {
      street = element.long_name
    }
    if (
      element.types.includes('sublocality') ||
      element.types.includes('sublocality_level_1')
    ) {
      colony = element.long_name
    }
    if (element.types.includes('postal_code')) {
      postalCode = parseInt(element.long_name)
    }
    if (element.types.includes('locality')) {
      city = element.long_name
    }
    if (element.types.includes('administrative_area_level_1')) {
      state = element.long_name
    }
    if (element.types.includes('country')) {
      country = element.long_name
    }
  }

  return {
    street,
    colony,
    postalCode,
    city,
    state,
    country,
  }
}
